
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6vx1i", function(module, exports) {
/* ReadingAidsAcronymsHighlighter.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $jmjWc = parcelRequire("jmjWc");


var $bjVRl = parcelRequire("bjVRl");

const $7618df873c80ee96$var$readingAidsPopupPortalContainerId = 'reading-aids-portal-container';

const $7618df873c80ee96$var$ReadingAidsSpotlightWrapper = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "7h_DJ",
    name: "ReadingAidsSpotlightWrapper",
    loader: async ()=>(await (parcelRequire("lhrLa"))).ReadingAidsSpotlightWrapper
});

const $7618df873c80ee96$var$ReadingAidsPopup = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "fofjy",
    name: "ReadingAidsPopup",
    loader: async ()=>(await (parcelRequire("dT0aH"))).ReadingAidsPopup
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7618df873c80ee96$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reoewfl _18m9ewfl _kqswh2mm _1pby1o8a",
            __cmplp.className
        ])
    });
});
const $7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent = ({ contentId: contentId })=>{
    const { showPopup: showPopup, autohighlightContext: autohighlightContext, autohighlightSelectionRect: autohighlightSelectionRect, autohighlightText: autohighlightText, sessionId: sessionId, showSpotlight: showSpotlight } = (0, $bjVRl.useReadingAidsState)();
    const portalContainerRef = (0, $42omo.useRef)(null);
    const { hideAutohighlightPopup: hideAutohighlightPopup, setPortalContainerRef: setPortalContainerRef } = (0, $bjVRl.useReadingAidsActions)();
    const selectionRect = {
        top: autohighlightSelectionRect.top,
        left: autohighlightSelectionRect.left,
        width: autohighlightSelectionRect.width,
        height: autohighlightSelectionRect.height
    };
    (0, $42omo.useEffect)(()=>{
        setPortalContainerRef({
            portalContainerRef: portalContainerRef
        });
    }, [
        portalContainerRef,
        setPortalContainerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$Container, {
        id: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        ref: portalContainerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsSpotlightWrapper, {
        contentId: contentId,
        selectionRect: selectionRect,
        showSpotlight: showSpotlight
    }), showPopup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsPopup, {
        selectedText: autohighlightText,
        additionalContext: autohighlightContext,
        selectionRect: selectionRect,
        isReadingAidsOpen: showPopup,
        onResult: ()=>{},
        onClose: hideAutohighlightPopup,
        contentId: contentId,
        popupPortalContainerId: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        isAutohighlighted: true,
        sessionId: sessionId
    }));
};
const $7618df873c80ee96$export$ffdc57aecb97ae41 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).KNOWLEDGE_DISCOVERY
})($7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent);
module.exports["ReadingAidsAcronymsHighlighter"] = $7618df873c80ee96$export$ffdc57aecb97ae41;

});

parcelRegister("lhrLa", function(module, exports) {

let $f7e0b7fe1134fa59$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f7e0b7fe1134fa59$var$load("fdsim").then(()=>parcelRequire('jgOPc'));

});

parcelRegister("dT0aH", function(module, exports) {

let $a1c08b7afbd32cee$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a1c08b7afbd32cee$var$load("h3ABO"),
    $a1c08b7afbd32cee$var$load("282rq"),
    $a1c08b7afbd32cee$var$load("djHM5"),
    $a1c08b7afbd32cee$var$load("eJQji"),
    $a1c08b7afbd32cee$var$load("2YffH"),
    $a1c08b7afbd32cee$var$load("aGWeM"),
    $a1c08b7afbd32cee$var$load("eEyVs"),
    $a1c08b7afbd32cee$var$load("6mHrv"),
    $a1c08b7afbd32cee$var$load("awWN9"),
    $a1c08b7afbd32cee$var$load("9CYct"),
    $a1c08b7afbd32cee$var$load("gQllS"),
    $a1c08b7afbd32cee$var$load("bxrdv"),
    $a1c08b7afbd32cee$var$load("hZtKG"),
    $a1c08b7afbd32cee$var$load("iNmaF"),
    $a1c08b7afbd32cee$var$load("lVO3w"),
    $a1c08b7afbd32cee$var$load("hyzoX"),
    $a1c08b7afbd32cee$var$load("h9Ed7"),
    $a1c08b7afbd32cee$var$load("eBRUf"),
    $a1c08b7afbd32cee$var$load("kbRvk"),
    $a1c08b7afbd32cee$var$load("k8QRJ"),
    $a1c08b7afbd32cee$var$load("43bfx"),
    $a1c08b7afbd32cee$var$load("cD6Zr"),
    $a1c08b7afbd32cee$var$load("9wzNh"),
    $a1c08b7afbd32cee$var$load("8YSo7"),
    $a1c08b7afbd32cee$var$load("3Zfzp"),
    $a1c08b7afbd32cee$var$load("9ldRJ"),
    $a1c08b7afbd32cee$var$load("50ame"),
    $a1c08b7afbd32cee$var$load("e7ZUf"),
    $a1c08b7afbd32cee$var$load("gL8bn"),
    $a1c08b7afbd32cee$var$load("ebWFc"),
    $a1c08b7afbd32cee$var$load("6iz6l"),
    $a1c08b7afbd32cee$var$load("4SCW2"),
    $a1c08b7afbd32cee$var$load("855o0"),
    $a1c08b7afbd32cee$var$load("8MfZE"),
    $a1c08b7afbd32cee$var$load("hv4mn"),
    $a1c08b7afbd32cee$var$load("Wowvf"),
    $a1c08b7afbd32cee$var$load("dek7I"),
    $a1c08b7afbd32cee$var$load("3SmkN"),
    $a1c08b7afbd32cee$var$load("dYtBN"),
    $a1c08b7afbd32cee$var$load("kNV5Y"),
    $a1c08b7afbd32cee$var$load("6wr18"),
    $a1c08b7afbd32cee$var$load("kjZZD"),
    $a1c08b7afbd32cee$var$load("2zxmz"),
    $a1c08b7afbd32cee$var$load("7269o"),
    $a1c08b7afbd32cee$var$load("3JSgG"),
    $a1c08b7afbd32cee$var$load("37ldp"),
    $a1c08b7afbd32cee$var$load("ffEVr"),
    $a1c08b7afbd32cee$var$load("dRpV3"),
    $a1c08b7afbd32cee$var$load("dTsOE"),
    $a1c08b7afbd32cee$var$load("hhss7"),
    $a1c08b7afbd32cee$var$load("jYUNl"),
    $a1c08b7afbd32cee$var$load("foy8I"),
    $a1c08b7afbd32cee$var$load("jY21r"),
    $a1c08b7afbd32cee$var$load("dP7ao"),
    $a1c08b7afbd32cee$var$load("hogcU"),
    $a1c08b7afbd32cee$var$load("i8eeg"),
    $a1c08b7afbd32cee$var$load("iFdoJ"),
    $a1c08b7afbd32cee$var$load("7EorR"),
    $a1c08b7afbd32cee$var$load("avRkh")
]).then(()=>parcelRequire('cmXz4'));

});


//# sourceMappingURL=ReadingAidsAcronymsHighlighter.248a184e.js.map
